(function(angular){
	'use strict';
	
	angular
		.module('iraModule')
		.controller('IraController', [
			'$filter',
			'$rootScope',
			'$timeout',
			'$window',
			'globalConfig',
			'iraTypes',
			'mixpanelFactory',
			'urlFactory',
			IraControllerFunction
		]);
	
	function IraControllerFunction(
		$filter,
		$rootScope,
		$timeout,
		$window,
		globalConfig,
		iraTypes,
		mixpanelFactory,
		urlFactory
	){
		var ira = this;

		ira.step = globalConfig.stepDefault;
		ira.onboardingStatus = globalConfig.onboardingStatus;
		ira.manualIraTypes = iraTypes;
		ira.iraTypes = angular.copy(iraTypes);
		
		ira.iraTypes = $filter('omit')(ira.iraTypes, function(type) {
			return type.value === 'SIMPLE';
		});
		
		if (globalConfig.iraTypeSelectedOnLoad) {
			ira.iraType = ($filter('filter')(ira.iraTypes, {'value': globalConfig.iraTypeSelectedOnLoad }, true))[0];
		} else {
			ira.iraType = ira.iraTypes[0];
		}

		ira.hasMTCAccount = false;
		ira.iraTypeManual = ira.iraTypes[0];

		ira.handleFundMTC = function() {
			var leavingFundriseData = {
				text: 'You will be redirected to Millennium Trust Company\'s website to fund your IRA.'
			};

			$rootScope.ModalFactory.openLeavingFundrise(leavingFundriseData)
				.then(function(modal) {
					modal.close.then(function(result) {
						if (result && result.success) {
							urlFactory.redirectNewTab('https://portal2.mtrustcompany.com/millennium/servlet/SmartForm.html?formCode=verification-form&disableInvestment=true&refCode=RIS&data=true');
						}
					});
				});
		};
		
		ira.handleOpenMTC = function() {
			var leavingFundriseData = {
				text: 'You will be redirected to DocuSign to complete the account opening application for our IRA partner, Millennium Trust Company.'
			};

			$rootScope.ModalFactory.openLeavingFundrise(leavingFundriseData)
				.then(function(modal) {
					modal.close.then(function(result) {
						if (result && result.success) {
							ira.submitOpen = true;
							mixpanelFactory.track('Open MTC Account Clicked');
							urlFactory.submitFormById('openIraAccountForm');
						}
						else {
							ira.openIraAccountFormSubmitted=false;
						}
					});
				});
		};
		
		ira.handleChangeType = function() {
			var leavingFundriseData = {
				text: 'You will be redirected to DocuSign to complete the account opening application for our IRA partner, Millennium Trust Company.'
			};

			$rootScope.ModalFactory.openLeavingFundrise(leavingFundriseData)
				.then(function(modal) {
					modal.close.then(function(result) {
						if (result && result.success) {
							ira.submitOpen = true;
							mixpanelFactory.track('Selected IRA Type Changed');
							urlFactory.submitFormById('openIraAccountForm');
						}
						else {
							ira.openIraChangeTypeFormSubmitted=false;
						}
					});
				});
		};

		ira.handleViewDocuSign = function() {
			var leavingFundriseData = {
				text: 'You will be redirected to DocuSign to complete the IRA account opening application for our IRA partner, Millennium Trust Company.'
			};

			$rootScope.ModalFactory.openLeavingFundrise(leavingFundriseData)
				.then(function(modal) {
					modal.close.then(function(result) {
						if (result && result.success) {
							urlFactory.redirect('/ira-onboarding/view-docusign');
						}
						else {
							ira.openIraCompleteDocusignFormSubmitted=false;
						}
					});
				});
		};
	}
})(window.angular);